import type { Locale } from "@porsche-customer/slfinrtl-context-types"

export const getRedirectLanguage = (marketplaceLanguages: Locale[], userPreferredLanguage: Locale | undefined) =>
	userPreferredLanguage
		? (marketplaceLanguages.find((marketLanguage) => marketLanguage === userPreferredLanguage) ??
			marketplaceLanguages.find(
				(marketLanguage) => marketLanguage.split("-")[0] === userPreferredLanguage.split("-")[0],
			) ??
			marketplaceLanguages[0] ??
			userPreferredLanguage)
		: marketplaceLanguages[0]
